/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-21 13:39:48
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-01 18:29:00
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/supplierPlan/QueryPage'
export const saveOrUpdate = '/icps/system/sign/dataCollection/supplierPlan/saveOrUpdate'
export const Download = '/icps/system/sign/dataCollection/supplierPlan/exportList'
/*供应详情*/
export function getPlanDetailById(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlan/getPlanDetailById',
    method: 'post',
    data
  })
}
/*获取计划*/
export function getLotAllotsByStation(data) {
  return request({
    url: '/icps/system/sign/dataCollection/lotMaintain/getLotAllotsByStation',
    method: 'post',
    data
  })
}
/*获取车辆合同*/
export function getContractCarByCondition(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getContractCarByCondition',
    method: 'post',
    data
  })
}
